/* Availability and budget are hard constraints. Curated rules rank first;
   current gift products provide an honest fallback when a rule is missing. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.GFFinderMatching = api;
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var ranges = { 'under-50': [0, 5000], '50-100': [5000, 10001], '100-150': [10000, 15001], '150-plus': [15000, Infinity] };
  function value(answers, key) { return answers[key] ? String(answers[key].value).trim().toLowerCase() : ''; }
  function corporate(answers) { return value(answers, 'recipient') === 'clients-teams' || value(answers, 'occasion') === 'corporate'; }
  function eligible(card, answers) {
    var range = ranges[value(answers, 'comfort_level')];
    return !!(range && card && card.available && card.image && card.url && Number.isFinite(card.priceCents) && card.priceCents >= range[0] && card.priceCents < range[1]);
  }
  function fallback(catalog, answers) {
    var occasion = { birthday: 'birthday-and-anniversary', 'thank-you': 'client-appreciation-and-thank-you', holiday: 'seasonal-holiday', 'just-because': 'thinking-of-you' }[value(answers, 'occasion')];
    return catalog.filter(function (p) { return eligible(p, answers); }).map(function (p, i) {
      var score = (p.collections || []).indexOf(occasion) >= 0 ? 10 : 0;
      if (value(answers, 'recipient') === 'the-family' && /family|pasta|pantry|pizza/i.test(p.title)) score += 2;
      return { card: p, score: score, order: i };
    }).sort(function (a, b) { return b.score - a.score || a.order - b.order; }).map(function (p) { return p.card; });
  }
  return { corporate: corporate, eligible: eligible, fallback: fallback };
});
